export default __webpack_public_path__ + "static/media/mitigation-basement-dehumidifier-setup.fd21bbd3.jpg";